export default "__VITE_ASSET__Cp$3s7ox__"